export enum PatientReportExportMode {
  DOWNLOAD = 'download',
  EHR = 'ehr',
}
